import { MaterialType, MaterialTypeDetail } from "src/generated/graphqlTypes";
import { useMaterialTypesQuery } from "./useMaterialTypes.generated";

/** Material types shown in the Material Catalog UI (excludes Placeholder). */
export const catalogMaterialTypes = [MaterialType.Construction, MaterialType.Product];

export function useMaterialTypes(): MaterialTypeDetail[] {
  const typesQuery = useMaterialTypesQuery({ fetchPolicy: "cache-first" });

  const types =
    typesQuery.data?.materialTypes ??
    Object.values(MaterialType).map((code, sortOrder) => ({ code, name: code.replace(/_/g, " "), sortOrder }));

  return types.filter((t) => t.code !== MaterialType.Placeholder);
}
